import { Alert, Collapse, Stack, Typography } from "@mui/material";
import { ErrorOutline } from "@mui/icons-material";

/**
 * Componente para mostrar mensajes de error en el login
 * Utiliza Alert de MUI con animación Collapse para mejor UX
 */
export default function ErrorMessage({ error }) {
  return (
    <Collapse in={Boolean(error)}>
      <Alert 
        severity="error" 
        icon={<ErrorOutline />}
        sx={{
          backgroundColor: "rgba(211, 47, 47, 0.1)",
          borderLeft: "4px solid #d32f2f",
          borderRadius: 2,
          "& .MuiAlert-icon": {
            color: "#f44336"
          },
          "& .MuiAlert-message": {
            width: "100%"
          }
        }}
      >
        <Stack spacing={0.5}>
          <Typography 
            variant="subtitle2" 
            sx={{ 
              fontWeight: 600, 
              color: "#f44336" 
            }}
          >
            Error de autenticación
          </Typography>
          <Typography 
            variant="body2" 
            sx={{ 
              color: "rgba(255,255,255,0.85)",
              fontSize: "0.875rem"
            }}
          >
            {error}
          </Typography>
        </Stack>
      </Alert>
    </Collapse>
  );
}

